import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
import { pinScrollPosition } from '../utils';
type Anchor = {
  id: string;
  top: number;
};

/**
 * Switching onboardings swaps every section below the strip. When the reader is partway down the
 * sections, this keeps the one they were reading at the same spot on screen, so they can flip
 * between onboardings and compare it.
 */
const useKeepSectionInView = selectedId => {
  const $ = _c(6);
  const stripRef = useRef(null);
  const panelRef = useRef(null);
  const anchorRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => Array.from(panelRef.current?.firstElementChild?.children ?? []);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const getSectionCards = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const stripBottom = stripRef.current?.getBoundingClientRect().bottom ?? 0;
      const panelTop = panelRef.current?.getBoundingClientRect().top ?? 0;
      const card = panelTop < stripBottom ? getSectionCards().find(section => section.getBoundingClientRect().bottom > stripBottom) : undefined;
      anchorRef.current = card ? {
        id: card.id,
        top: card.getBoundingClientRect().top
      } : null;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rememberSectionInView = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const anchor = anchorRef.current;
      anchorRef.current = null;
      const card_0 = anchor && getSectionCards().find(section_0 => section_0.id === anchor.id);
      if (!anchor || !card_0) {
        return;
      }
      return pinScrollPosition(card_0, anchor.top);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selectedId) {
    t3 = [selectedId];
    $[3] = selectedId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      stripRef,
      panelRef,
      rememberSectionInView
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default useKeepSectionInView;